import Axios from 'axios';

export class Address {
   public 'id': string;
/**
* Address Name - Home, Office etc
*/
   public 'name': string;
/**
* Level, Building, Apartment, extra info
*/
   public 'additional': string;
/**
* First line of address
*/
   public 'address1': string;
/**
* Second line of address e.g. RD1
*/
   public 'address2': string;
   public 'suburb': string;
   public 'city': string;
   public 'postcode': string;
/**
* Region, State, Province
*/
   public 'region': string;
/**
* New Zealand as Default
*/
   public 'country': string;
   public 'latitude': string;
   public 'longitude': string;
   public 'defaultStore': string;
   public 'display': string;

    constructor(partial?: Partial<Address>) {
        
        Object.assign(this, partial);
    }
}

export class AutocompleteAddressCollection {
   public 'addresses': BasicAddress[];

    constructor(partial?: Partial<AutocompleteAddressCollection>) {
        
        Object.assign(this, partial);
    }
}

export class BasicAddress {
   public 'id': string;
   public 'description': string;

    constructor(partial?: Partial<BasicAddress>) {
        
        Object.assign(this, partial);
    }
}

export class FaqItem {
   public 'id': string;
   public 'question': string;
   public 'answer': string;
   public 'category': string;

    constructor(partial?: Partial<FaqItem>) {
        
        Object.assign(this, partial);
    }
}

export class InlineFaq {
   public 'faq': FaqItem[];

    constructor(partial?: Partial<InlineFaq>) {
        
        Object.assign(this, partial);
    }
}

export class Shopper {
   public 'id': string;
   public 'email': string;
   public 'firstName': string;
   public 'lastName': string;
   public 'phone': string;
   public 'allowSubstitutions': boolean;
   public 'password': string;
   public 'agreedToTermsAndConditions': boolean;
   public 'agreedToMarketing': boolean;

    constructor(partial?: Partial<Shopper>) {
        
        Object.assign(this, partial);
    }
}

export class AddressApiServiceClass {
    public servicePath: string = '';

    public basePath: string = '/address';

    public authToken: string;

    /**
    *
   */
    public autocompleteAddress(address?: string,  authToken?: string): Promise<AutocompleteAddressCollection> {
        const _localVarPath = this.servicePath+this.basePath+'';
        const _params: any = {};

        if (address !== undefined) {
            _params['address'] =  address;
        }

        const _formParams: any = {};

        let _bodyData;

        return new Promise<AutocompleteAddressCollection>((resolve, reject) => {
            Axios({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<AutocompleteAddressCollection>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public getAutocompleteAddressDetails(id: string,  authToken?: string): Promise<Address> {
        const _localVarPath = this.servicePath+this.basePath+'/{id}'.replace('{' + 'id' + '}', String(id));
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        return new Promise<Address>((resolve, reject) => {
            Axios({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<Address>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export const AddressApiService = new AddressApiServiceClass();
export class FaqApiServiceClass {
    public servicePath: string = '';

    public basePath: string = '/faq';

    public authToken: string;

    /**
    *
   */
    public getFaqs( authToken?: string): Promise<InlineFaq> {
        const _localVarPath = this.servicePath+this.basePath+'';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        return new Promise<InlineFaq>((resolve, reject) => {
            Axios({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<InlineFaq>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export const FaqApiService = new FaqApiServiceClass();



// WEBPACK FOOTER //
// ./src/services/generated/edge/info/index.ts